module.exports = __webpack_public_path__ + "static/assets/52d442dc8e71307ec251603d1edd35f0.mp3";